











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JoinMeetingMutation_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "meeting",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingSelector_meeting"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingCard_meeting"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JoinMeetingSuccess",
  "abstractKey": null
};

(node ).hash = "a801c53a6714503043878d1c4ea7d90b";

export default node;
